export default __webpack_public_path__ + "static/media/33.8e674584.svg";